export default "__VITE_ASSET__Ceo3iw9A__"